<template>
    <div class="inspectionRecords">
        <el-container direction="vertical">
            <div style="background-color: rgb(255, 255, 255); border: 1px solid #eee;">
                <el-row direction="horizontal" style="margin-top: 10px;">
                    <el-col :span="6">
                        <el-card :style="{ 'margin-left': '10px', 'width': '210px', 'background-color': regularColor }"
                            @click.native="cardClick(1)">
                            <div>
                                <el-statistic :value="overviewData1.value" :title="overviewData1.title"
                                    :value-style="{ color: 'cornflowerblue' }">
                                    <template slot="prefix">
                                        <i class="el-icon-s-flag" style="color: cornflowerblue"></i>
                                    </template>
                                </el-statistic>
                            </div>
                        </el-card>
                    </el-col>

                    <el-col :span="6">
                        <el-card :style="{ 'margin-left': '10px', 'width': '210px', 'background-color': previewColor }"
                            @click.native="cardClick(0)">
                            <div>
                                <el-statistic :value="overviewData2.value" :title="overviewData2.title"
                                    :value-style="{ color: 'red' }">
                                    <template slot="prefix">
                                        <i class="el-icon-s-flag" style="color: red"></i>
                                    </template>
                                </el-statistic>
                            </div>
                        </el-card>
                    </el-col>

                    <!-- <el-col :span="6">
                        <el-card style="margin-left: 10px;width: 210px;">
                            <div>
                                <el-statistic :value="overviewData3.value" :title="overviewData3.title"
                                    :value-style="{ color: 'cornflowerblue' }">
                                    <template slot="prefix">
                                        <i class="el-icon-s-flag" style="color: cornflowerblue"></i>
                                    </template>
                                </el-statistic>
                            </div>
                        </el-card>
                    </el-col>

                    <el-col :span="6">
                        <el-card style="margin-left: 10px;width: 210px;">
                            <div>
                                <el-statistic :value="overviewData4.value" :title="overviewData4.title"
                                    :value-style="{ color: 'red' }">
                                    <template slot="prefix">
                                        <i class="el-icon-s-flag" style="color: red"></i>
                                    </template>
                                </el-statistic>
                            </div>
                        </el-card>
                    </el-col> -->
                </el-row>

                <el-row style="margin-top: 40px;">
                    <el-col class="form">
                        <el-form :model="formData" label-width="80px">
                            <!-- <el-form-item label="检测机构">
                                <patientTree @input="input"></patientTree>
                            </el-form-item> -->
                            <el-form-item label="患者姓名">
                                <el-input v-model="formData.measurerName"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="三级医师">
                                <el-input v-model="formData.doctorLevel3Name"></el-input>
                            </el-form-item>
                            <el-form-item label="风险等级">
                                <el-select v-model="formData.risk" placeholder="全部">
                                    <el-option label="全部" :value="null"></el-option>
                                    <el-option label="绿色" value="1"></el-option>
                                    <el-option label="黄色" value="2"></el-option>
                                    <el-option label="红色" value="3"></el-option>
                                </el-select>
                            </el-form-item> -->
                            <el-form-item label="血压危险">
                                <el-select v-model="formData.critical" placeholder="全部">
                                    <el-option label="全部" :value="null"></el-option>
                                    <el-option label="危急值" value="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="访问方式">
                                <el-select v-model="formData.measurerType" placeholder="全部">
                                    <el-option label="全部" :value="null"></el-option>
                                    <el-option label="门诊" value="门诊"></el-option>
                                    <el-option label="家庭" value="家庭"></el-option>
                                    <el-option label="电话" value="电话"></el-option>
                                    <el-option label="视频" value="视频"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="来源">
                                <el-select v-model="formData.fromSource" placeholder="全部">
                                     <el-option v-for="x in sourceOptions" :key="x.value" :label="x.label" :value="x.value">
                                </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="测量时间">
                                <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" style="margin-left: 10px"
                                    @click="getBloodPressureList">查询</el-button>
                            </el-form-item>
                            <!-- <el-form-item>
                                <el-button type="primary" style="margin-left: 10px" @click="reportExportToExcel">导出</el-button>
                            </el-form-item> -->
                        </el-form>
                    </el-col>
                    <el-col>
                        <el-table class="inspectionTable" v-loading="listLoading" :data="manageList" fit>
                            <el-table-column width="150px" align="center" label="测量时间">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.time || "-" }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" label="姓名">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.measurerName || "-" }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column width="170px" align="center" label="身份证号">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.measurerIdentityCard || "-" }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" label="血压值">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.systolicPressure || "-" }}/{{ scope.row.diastolicPressure || "-"
                                        }}</span>
                                    <span :class="scope.row.riskType" style="margin-left: 5px;margin-top:0px;"></span>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" label="来源">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.fromSource || "-" }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column width="156" align="center" label="三级医师（压）">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.doctorLevel3Name || "-" }}</span>
                                </template>
                            </el-table-column>

                            <!-- <el-table-column align="center" label="测量机构">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.dataSources }}</span>
                                </template>
                            </el-table-column> -->

                            <el-table-column width="250" align="center" label="操作">
                                <template slot-scope="scope">
                                    <el-button style="margin-left: 0px; align-self: center" type="text"
                                        @click="patientsDetail(scope.row)">
                                        健康档案
                                    </el-button>
                                    <!-- <el-button style="margin-left: 5px; align-self: center" type="text"
                                        @click="onetalkConsultationDialog(scope.row)">向下协诊</el-button>

                                    <el-button style="margin-left: 5px; align-self: center" type="text"
                                        @click="diagnoseDialog(scope.row)">向上转诊</el-button> -->

                                    <el-button style="margin-left: 5px; align-self: center" type="text"
                                        @click="codiag(scope.row)">一键协诊</el-button>

                                    <el-button style="margin-left: 5px; align-self: center" type="text"
                                        @click="patientFollowup(scope.row)">随访</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                    <el-col>
                        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum"
                            :limit.sync="listQuery.pageSize" @pagination="turnToPage" />
                        <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>
                        <onetalkConsultationDialog @upDataList="upDataList" v-if="onetalkConsultationVisialbe"
                            ref="onetalkConsultationRef">
                        </onetalkConsultationDialog>
                        <diagnoseDialog v-if="diagnoseDialog" ref="diagnoseDialogRef"></diagnoseDialog>
                        <codiagDiag v-if="codiagDiagVisible" ref="codiagDiagRef">
                        </codiagDiag>
                        <new-follow-up v-if="newFollowUpVisible" ref="newFollowUpRef"></new-follow-up>
                    </el-col>
                </el-row>
            </div>
        </el-container>
    </div>
</template>

<script>
import {
    getBloodPressureList,
    turnToBloodPressureList,
    reportToExcel,
    getBloodPressureCount,
    getLisMeasureTips, 
    getSysDicList
} from "@/api/health/Patients";
import Pagination from "@/components/Pagination";
import patientDetail from "@/views/patient/patientDetail";
import onetalkConsultationDialog from "./consultationComponents/onetalkConsultationDialog.vue";
import diagnoseDialog from "./consultationComponents/diagnoseDialog.vue";
import patientTree from '@/components/selectTree';
import { Loading } from "element-ui";
import moment from "moment";
import codiagDiag from "../integration/codiagDiag.vue";
import newFollowUp from "../followup/newFollowUp.vue";

export default {
    components: { Pagination, patientDetail, patientTree, onetalkConsultationDialog, diagnoseDialog, codiagDiag, newFollowUp },
    data() {
        return {
            patientDetailVisible: false,
            onetalkConsultationVisialbe: false,
            diagnoseDialogVisialbe: false,
            codiagDiagVisible: false,
            newFollowUpVisible: false,
            formData: {
                risk: null,
                critical: null,
                measurerName: null,
                measureType: null,
                measurerType: null,
                fromSource: null,
                doctorLevel3Name: null,
                managerHospitals: [],
                startTime: null,
                endTime: null,
                reachTarget: 1,
            },
            data: [],
            valueData: null,
            manageList: [],
            listLoading: false,
            total: 0,
            loadingOptions: {
                text: "正在导出...",
                background: "rgba(0, 0, 0, 0.6)",
            },
            listQuery: {
                pageNum: 1,
                pageSize: 10
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: "今天",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime());
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
            exportBody: {
                url: "/business/iotBloodPressure/list",
                headers: ['测量时间', '姓名', '身份证号', '血压值', '三级医师（压）', '测量机构'],
                keys: ["time", "measurerName", "measurerIdentityCard", "diastolicPressure", "doctorLevel3Name", 'dataSources'],
                body: null,
            },
            overviewData1: {
                value: 0,
                title: "血压检测达标人次",
            },
            overviewData2: {
                value: 0,
                title: "血压检测未达标人次",
            },
            overviewData3: {
                value: 368,
                title: "血压检测规范人数",
            },
            overviewData4: {
                value: 55,
                title: "血压检测不规范人数",
            },
            regularColor: '#ECF5FF',
            previewColor: '#ffffff',
              sourceOptions: [], // 指标来源
        }
    },
    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        this.valueData = [start, end];

        // this.getBloodPressureListCount();
        this.getBloodPressureList();
        this.getListTipsMethod();
          this.getSourceSystemDictList("指标来源");
    },
    watch: {
        "formData.measurerType": {
            handler(newV) {
                console.warn('来源：', newV);
                this.formData.measureType = newV;
            },
            immediate: true
        }
    },
    methods: {
         getSourceSystemDictList(typeName) {
            var typeData = {
                "typeName": typeName
            };
            getSysDicList(typeData).then(res => {
                var records = [];
                if (res.msg == "success") {
                    var data = res.data;
                    records = data.records;
                }
                this.sourceOptions = records?.map(x => ({ label: x.name, value: x.name }));
                this.sourceOptions = [{ label: "全部", value: null }, ...this.sourceOptions]
            }).catch(err => {
                console.log(err);
            })
        },
        // getBloodPressureListCount() {
        //     var param = {};
        //     getBloodPressureCount(param).then((res) => {
        //         if (res.msg == "success") {
        //             console.log('血压检测人次：', res);
        //         }
        //     });
        // },
        getListTipsMethod() {
            var param = { type: '血压' };
            getLisMeasureTips(param).then((res) => {
                if (res.msg == "success") {
                    var data = res.data[0];
                    this.overviewData1.value = data.countReachTarget;
                    this.overviewData2.value = data.countUnReachTarget;
                }
            }).catch(error => {
                console.log(error);
            });
        },
        //查询结果导出
        reportExportToExcel() {
            console.log(
                "查询结果导出",
                `表格${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
            );

            let loadingInstance = Loading.service(this.loadingOptions);

            this.exportBody.url = '/business/iotBloodPressure/list?page=' + this.listQuery.pageNum + '&pageSize=' + this.listQuery.pageSize;

            this.exportBody.body = Object.assign({}, this.listQuery, this.formData);
            console.log("导出表格请求body：", this.exportBody);

            reportToExcel(this.exportBody)
                .then((res) => {
                    console.log("查询表格导出====", res);

                    this.$nextTick(() => {
                        loadingInstance.close();
                    });

                    let blob = new Blob([res], { type: "application/force-download" });
                    console.log(blob);
                    let fileReader = new FileReader();
                    fileReader.readAsDataURL(blob);
                    fileReader.onload = (e) => {
                        let a = document.createElement("a");
                        a.download = `血压检测${moment(new Date()).format(
                            "YYYYMMDDHHmm"
                        )}.xlsx`;
                        a.href = e.target.result;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    };
                })
                .catch((error) => {
                    this.$nextTick(() => {
                        loadingInstance.close();
                    });

                    console.log(error);

                    this.$message({
                        message: "导出失败",
                        type: "error",
                    });
                });
        },
        //一键协诊
        codiag(rowValue) {
            this.codiagDiagVisible = true;

            rowValue.refType = '血压';
            rowValue.codiagServiceName = '血压';
            rowValue.codiagStatus = '待协诊';
            console.log('血压检测一键协诊：', rowValue);

            this.$nextTick(() => {
                this.$refs['codiagDiagRef'].init(rowValue);
            })
        },
        //随访
        patientFollowup(row) {
            this.newFollowUpVisible = true;
            row.serviceName = '高血压随访';
            this.$nextTick(() => {
                this.$refs["newFollowUpRef"].init(row);
            });
        },
        // 跳转诊断列表
        diagnoseDialog(row) {
            // if (!row.ehr) {
            //     this.$message({
            //         message: "该患者尚未建立个人档案，请先建立！",
            //         type: "warning"
            //     })
            // } else {
            //     this.diagnoseDialogVisialbe = true;
            //     this.$nextTick(() => {
            //         this.$refs['diagnoseDialogRef'].init(row);
            //     })
            // }

            this.diagnoseDialogVisialbe = true;
            this.$nextTick(() => {
                this.$refs['diagnoseDialogRef'].init(row);
            })
        },
        // 跳转至相应病人档案详情页
        patientsDetail(row) {
            // if (!row.ehr) {
            //     this.$message({
            //         message: "该患者尚未建立个人档案，请先建立！",
            //         type: "warning"
            //     })
            // } else {
            //     this.patientDetailVisible = true;
            //     this.$nextTick(() => {
            //         this.$refs["PatientDetailRef"].init(row.ehr);
            //     });
            // }

            console.log("跳转患者详情：", row);

            this.patientDetailVisible = true;
            if (row.idcard == null) {
                row.idcard = row.measurerIdentityCard;
            }
            this.$nextTick(() => {
                this.$refs["PatientDetailRef"].init(row);
            });
        },
        // 跳转协诊记录表
        onetalkConsultationDialog(row) {
            // if (!row.ehr) {
            //     this.$message({
            //         message: "该患者尚未建立个人档案，请先建立！",
            //         type: "warning"
            //     })
            // } else {
            //     this.onetalkConsultationVisialbe = true;
            //     this.$nextTick(() => {
            //         this.$refs['onetalkConsultationRef'].init(row);
            //     })
            // }

            this.onetalkConsultationVisialbe = true;
            this.$nextTick(() => {
                this.$refs['onetalkConsultationRef'].init(row);
            })
        },
        // 获取系统时间
        getSystemTime() {
            var newTime = new Date(time);
            // 获取完整的年份(4位)
            var year = newTime.getFullYear();
            // 获取月份(0-11,0代表1月)
            var month = newTime.getMonth() + 1;
            // 获取日期(1-31)
            var date = newTime.getDate();

            return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
        },
        cardClick(value) {
            console.log('达标：', value);
            if (value == '1') {
                //达标
                this.regularColor = '#ECF5FF';
                this.previewColor = '#ffffff';
            } else {
                //未达标
                this.regularColor = '#ffffff';
                this.previewColor = '#ECF5FF';
            }

            this.formData.reachTarget = value;
            this.getBloodPressureList();
        },
        getBloodPressureList() {
            if (this.valueData != null) {
                this.formData.startTime = this.valueData[0] ? this.getParseDate(this.valueData[0], 1) : null;
                this.formData.endTime = this.valueData[1] ? this.getParseDate(this.valueData[1], 2) : null;
            } else {
                this.formData.startTime = null;
                this.formData.endTime = null;
            }
            let params = Object.assign({}, this.listQuery, this.formData)
            this.listLoading = true;
            getBloodPressureList(params).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.manageList = res.data.records;
                    this.total = res.data.total;

                    this.manageList.forEach((item, index) => {
                        this.manageList[index].riskType = this.setRiskType(item)
                            ? this.setRiskType(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 日期格式转化
        getParseDate(time, type) {
            if (type == 1) {
                var newTime = new Date(time);
            } else if (type == 2) {
                var newTime = new Date(((new Date(time) / 1000) + 86400) * 1000);
            }
            // 获取完整的年份(4位)
            var year = newTime.getFullYear();
            // 获取月份(0-11,0代表1月)
            var month = newTime.getMonth() + 1;
            // 获取日期(1-31)
            var date = newTime.getDate();

            return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
        },
        // 获取机构数组
        input(value) {
            this.formData.managerHospitals = value;
        },
        // 导航跳转查询列表页
        turnToPage() {
            if (this.formData.bloodsugarLe > this.formData.bloodsugarGe) {
                this.$message({
                    message: "血糖范围左侧值必须小于右侧值，请重选后再次查询！",
                    type: "error"
                })
                return;
            }
            if (this.valueData != null) {
                this.formData.startTime = this.valueData[0] ? this.getParseDate(this.valueData[0], 1) : null;
                this.formData.endTime = this.valueData[1] ? this.getParseDate(this.valueData[1], 2) : null;
            } else {
                this.formData.startTime = null;
                this.formData.endTime = null;
            }
            let params = Object.assign({}, this.listQuery, this.formData)
            this.listLoading = true;
            turnToBloodPressureList(params).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.manageList = res.data.records;
                    this.total = res.data.total;

                    this.manageList.forEach((item, index) => {
                        this.manageList[index].riskType = this.setRiskType(item)
                            ? this.setRiskType(item)
                            : "labelNone";
                    });
                }
            });
        },
        setRiskType(row) {
            if (row.codiagStatus == 0) {
                if (row.risk == 3) {
                    return "labelRed";
                } else if (row.risk == 2) {
                    return "labelYellow";
                } else if (row.risk == 1) {
                    return "labelGreen1";
                }
            } else {
                return "labelNone";
            }
        },
        // 修改条纹颜色
        tableRowClassName({ row, rowIndex }) {
            if (row.codiagStatus == 0) {
                if (row.risk == 3) {
                    return 'light-row'
                } else if (row.risk == 2) {
                    return 'aterrimus-row'
                } else if (row.risk == 1) {
                    // return 'green-row'
                }
            } else {
                return;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.labelNone {
    display: none;
}

.labelRed {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    border: 1px solid gray;
    color: white;
    background: red;
    display: inline-block;
}

.labelYellow {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    border: 1px solid gray;
    color: white;
    background: yellow;
    display: inline-block;
}

.labelGreen1 {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    border: 1px solid gray;
    color: white;
    background: green;
    display: inline-block;
}

.inspectionTable {
    ::v-deep {
        .light-row {
            background: rgba(255, 0, 0, 0.579) !important;
        }

        .aterrimus-row {
            //黄
            background: yellow !important;
        }

        .green-row {
            background: greenyellow;
        }

        .el-table__cell {
            height: 50px !important;
        }
    }

}


.form ::v-deep {
    .el-form-item {
        display: inline-flex;
    }

    .el-input--medium .el-input__inner {
        width: 209px !important;
    }

    .el-form-item__content {
        margin-left: 10px !important;
    }
}
</style>